module.exports = __webpack_public_path__ + "img/hire3xlogo-small.8d4dd1d9.svg";